<section id="cta" aria-labelledby="cta-heading" class="border-t border-cp-line">
  <div [class]="inner + ' py-28 text-center lg:py-40'">
    <h2 id="cta-heading" [class]="hClose + ' mx-auto'">
      <span class="lg:block">Clients are getting credit somewhere.</span>
      <span class="text-cp-muted lg:block">Shouldn't it be through you?</span>
    </h2>
    <div class="mt-10 flex flex-wrap justify-center gap-3">
      <button type="button" (click)="onRequestTerms()" [class]="btnPrimary">Request Terms</button>
      <a routerLink="/contact" [class]="btnSecondary">Contact Us</a>
    </div>
  </div>
</section>
